import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'

import { Context } from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsContext'
import AcquiringSettlementsFilter from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsFilter'
import AcquiringChargesStepper from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsStepper'
import SettlementsTable from 'components/core/Acquiring/AcquiringSettlements/components/AcquiringSettlementsTable'
import { parseTableData } from 'components/core/Acquiring/AcquiringState'
import { ErrorAlert } from 'components/core/Alert'
import { RootState } from 'redux/store'

const AcquiringSettlements = () => {
    const { t } = useTranslation()
    const {
        acquiring: { cardAcquiringSettlements, loader },
    } = useSelector((state: RootState) => state)

    const [settlementsInputs, setSettlementsInputs] = useState<ISettlementsInputs>({ from: null, to: null, skip: null, take: null })

    const settlements: ISettlementsRecordsParsed = useMemo(() => parseTableData(cardAcquiringSettlements), [cardAcquiringSettlements])

    const contextValues = { settlementsInputs, setSettlementsInputs, settlements, loader }

    return (
        <Context.Provider value={contextValues}>
            <div>
                <h3>{t('Acquiring.Settlements')}</h3>
                <ErrorAlert />
                <AcquiringSettlementsFilter />
                <SettlementsTable />
                <AcquiringChargesStepper />
            </div>
        </Context.Provider>
    )
}

export default AcquiringSettlements
